import React from "react";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { Row } from "reactstrap";
import { faCheckCircle } from "@fortawesome/free-solid-svg-icons";
import { IMessage } from "../../model/message.model";
import { Modal } from "react-bootstrap";

interface IProps {
  message: IMessage;
}

export const SuccessRequest = (props: IProps) => {
  const { message } = props;

  return (
    <Modal.Body className="modal-body-generic">
      <Row className="text-center justify-content-center text-success">
        <FontAwesomeIcon size="3x" icon={faCheckCircle} />
      </Row>
      <Row className="text-center justify-content-center text-black mt-2 row-response text-modal-title">
        <h4>
          {message.title}
          {/* <Translate contentKey={message}>successfully</Translate> */}
        </h4>
      </Row>
      <Row className="text-center justify-content-center text-black mt-2 row-response text-modal-subtitle">
        {message?.body && <p>{message.body}</p>}
        {message?.footer && <p>{message.footer}</p>}
      </Row>
    </Modal.Body>
  );
};
